// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ChatFilesPanel_overlay__Suo5N","panel":"ChatFilesPanel_panel__JpYka","header":"ChatFilesPanel_header__ZfcMI"};